import { render, staticRenderFns } from "./RefLink.vue?vue&type=template&id=46e400fb&scoped=true&"
import script from "./RefLink.vue?vue&type=script&lang=js&"
export * from "./RefLink.vue?vue&type=script&lang=js&"
import style0 from "./RefLink.vue?vue&type=style&index=0&id=46e400fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e400fb",
  null
  
)

export default component.exports